import { useEffect, useState } from 'react'

const useGetConfigFile = () => {
    const [apiUrl, setApiUrl] = useState(null)
    const [dataUrl, setDataUrl] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/config.json`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Błąd podczas ładowania konfiguracji");
                }
                return response.json()
            })
            .then((data) => {
                setApiUrl(data.apiUrl)
                setDataUrl(data.dataUrl)
                setLoading(false)
            })
            .catch((e) => {
                console.error("Error loading config:", e)
                setError(e)
                setLoading(false)
            })
    }, [])

    return { apiUrl, dataUrl, loading, error }
}

export default useGetConfigFile

